import * as React from 'react';
import { SingleColumnLayout } from '../../designSystem/layouts/SingleColumnLayout';
import { H2 } from '../../designSystem/typography/Heading';
import { Small } from '../../designSystem/typography/Body';
import { Flex } from '../../designSystem/compositeComponents/FlexHelpers';
import { OnOff } from '../../designSystem/inputs/OnOff';

export function DesignSystemPage(
    props:React.PropsWithChildren
)
{
    return (
        <SingleColumnLayout
            noDivider
            wide
            contentContainer={
                <Flex flexDirection="column" gap={16}>
                    {props.children}
                </Flex>
            }
        />
    )
}

export function DesignSystemSection(
    props:React.PropsWithChildren<{
        title:string
    }>
):JSX.Element
{
    const [darkBackground, setDarkBackground] = React.useState(false);

    return (
        <div style={{ display:'flex', flexDirection:'column', padding:20, paddingTop:16, border:'1px solid #ccc', borderRadius:4,
            backgroundColor: darkBackground ? '#646464' : '#fff'
         }}>
            <Flex alignItems="center" justifyContent="space-between" style={{ marginBottom: 16 }}>
                <H2>{props.title}</H2>
                <Flex gap={8}>Dark background <OnOff active={darkBackground} onClick={setDarkBackground} /></Flex>
            </Flex>
            <Flex flexDirection="column" gap={32}>
                {props.children}
            </Flex>
        </div>
    )
}

export function DesignSystemSectionRow(
    props:React.PropsWithChildren<{
        title:string
    }>
):JSX.Element
{
    return (
        <div style={{ display:'flex', flexDirection:'column'}}>
            <Small style={{fontWeight:'bold'}}>{props.title}</Small>
            <Flex flexDirection="row" justifyContent="flex-start" gap={20} flexWrap="wrap">
                {props.children}
            </Flex>
        </div>
    )
}